// All user-facing strings. Keys must exist in both languages — tests/i18n.test.ts enforces parity.
export const zh = {
  'app.name': 'JY Games',
  'app.tagline': "一起玩，一起動腦。",
  'nav.home': '首頁',
  'nav.play': '開始遊戲',
  'nav.learn': '規則教學',
  'nav.leaderboard': '排行榜',
  'nav.history': '對局紀錄',
  'nav.profile': '玩家資料',
  'nav.settings': '設定',
  'nav.about': '關於',
  'nav.privacy': '隱私權政策',
  'nav.terms': '服務條款',
  'nav.menu': '選單',
  'nav.skip': '跳到主要內容',
  // home & shared UI v1 (docs/design/home-shared-ui-v1/copy.json)
  'home.v2.intro': "先選一款，再選玩法。",
  'home.v2.play': "開始玩",
  'home.v2.rules': "玩法",
  'home.v2.playLabel': "開始玩：{game}",
  'home.v2.rulesLabel': "查看玩法：{game}",
  'home.v2.chess.desc': "保護國王，想辦法將死對手。",
  'home.v2.xiangqi.desc': "調動車馬炮，將死對方將帥。",
  'home.v2.banqi.desc': "翻棋、走棋，看準機會吃子。",
  'home.v2.territory.desc': "走出路線，回到領地完成圈地。",
  'home.v2.snake.desc': "吃食物變長，小心別撞上。",
  'home.v2.blocks.desc': "移動、旋轉方塊，排滿一行消除。",
  'home.v2.sudoku.desc': "填入 1–9，同列、同行、九宮不重複。",
  'home.v2.doodle.desc': "混出顏色，畫出自己的作品。",
  'game.doodle': "色彩塗鴉樂",
  'game.coaster': "手繪雲霄飛車",
  'game.bumper': "瘋狂碰碰車",
  'home.v2.bumper.desc': "選動物開碰碰車，60 秒撞出最多星星。",
  'game.taxi': "狂飆小黃",
  'home.v2.taxi.desc': "開小黃在港都載客，甩尾衝刺，限時賺最多車資。",
  'home.v2.coaster.desc': "畫一條線當軌道，再用第一人稱坐上去。",
  'game.math': "數學遊樂島",
  'home.v2.math.desc': "一年級蘋果籃、三年級分裝工廠：動手擺一擺，再數一數。",
  'game.doodle.en': "Color Doodle",
  'game.doodle.desc': "打開就能畫畫，在調色盤上用紅黃藍白黑混出 24 種顏色，完成短任務，作品存成圖片。",
  'nav.allGames': "所有遊戲",
  'nav.primaryLabel': "主要導覽",
  'nav.menuLabel': "網站選單",
  'nav.openMenu': "開啟選單",
  'nav.closeMenu': "關閉選單",
  'theme.changeLabel': "目前：{current}；切換為：{next}",
  'common.loadingLabel': "載入中",
  'nav.group.games': "遊戲",
  'nav.group.more': "其他",
  'nav.group.account': "帳號",
  'lang.switch': 'English',
  'lang.label': '語言',

  'game.chess': '西洋棋',
  'game.xiangqi': '中國象棋',
  'game.banqi': '台灣暗棋',
  'game.chess.en': 'Chess',
  'game.xiangqi.en': 'Xiangqi',
  'game.banqi.en': 'Banqi',
  'game.chess.desc': "守住自己的國王，設法將死對手。從基本走法開始，逐步學會西洋棋的攻守。",
  'game.xiangqi.desc': "隔著楚河漢界鬥智，運用車、馬、炮進攻。採本站公開的象棋規則，含簡化長將、長捉裁決。",
  'game.banqi.desc': "翻開棋子，觀察局勢，再決定移動或吃子。預設採台灣常見版，開局前可查看完整局規。",

  'home.hero.title': '七款好遊戲，一場即時對決',
  'home.hero.sub': "棋藝、即時競技與益智方塊：自己練習、和家人同機玩，或邀請朋友線上對戰。第一次玩也有教學帶你開始。",
  'home.cta.play': '開始遊戲',
  'home.cta.learn': '學習規則',
  'home.features.ai': '三級電腦 AI',
  'home.features.ai.desc': '簡單、中等、困難，棋力差異清楚，孩子與高手都適用。',
  'home.features.online': '即時線上對戰',
  'home.features.online.desc': "建立房間邀請朋友，或透過配對尋找對手。",
  'home.features.learn': '互動式教學',
  'home.features.learn.desc': '一步一步動手練習，完成指定走法才進入下一課。',
  'home.features.coach': 'AI 棋藝教練',
  'home.features.coach.desc': '提示、失誤提醒與賽後分析，全部依據引擎計算。',

  'hub.vsAi': '與電腦對戰',
  'hub.vsAi.desc': '選擇難度，隨時練習。',
  'hub.local': '雙人同機',
  'hub.local.desc': '同一台裝置輪流下棋。',
  'hub.match': '線上配對',
  'hub.match.desc': '自動尋找實力相近的對手。',
  'hub.room': '建立私人房間',
  'hub.room.desc': '產生邀請連結給朋友。',
  'hub.learn': '規則教學',
  'hub.learn.desc': '互動練習，從棋子名稱學起。',
  'hub.practice': 'AI 練習模式',
  'hub.practice.desc': '教練全程陪練，可提示可悔棋。',
  'hub.join': '輸入房間代碼',
  'hub.join.btn': '加入',

  'setup.title': '對局設定',
  'setup.level': '電腦難度',
  'level.easy': '簡單',
  'level.medium': '中等',
  'level.hard': '困難',
  'level.easy.desc': '適合兒童與初學者，會出現失誤。',
  'level.medium.desc': '具備基本攻守與戰術。',
  'level.hard.desc': '深度搜尋，適合有經驗的玩家。',
  'setup.side': '我方',
  'side.first': '先手',
  'side.second': '後手',
  'side.random': '隨機',
  'side.white': '白方',
  'side.black': '黑方',
  'side.red': '紅方',
  'side.blackXq': '黑方',
  'setup.time': '時間控制',
  'setup.time.none': '不限時',
  'setup.time.fmt': '{m} 分 + {s} 秒',
  'setup.allowUndo': '允許悔棋',
  'setup.coach': '開啟 AI 教練',
  'setup.rules': '暗棋規則',
  'setup.rated': '計分對局',
  'setup.rated.desc': '需登入，結果影響積分。',
  'setup.start': '開始對局',
  'preset.taiwan': '台灣常見版',
  'preset.taiwan_chain': '台灣常見版＋連吃',
  'preset.strict_rank': '嚴格階級版',

  'board.turn': '輪到 {side}',
  'board.yourTurn': '輪到你了',
  'board.thinking': '電腦思考中…',
  'board.check': '將軍！',
  'board.checkChess': '將軍（Check）！',
  'board.flip': '翻棋',
  'board.hidden': '未翻開的棋子',
  'board.empty': '空格',
  'board.square': '{sq}',
  'board.legalHint': '可走位置',
  'board.lastMove': '上一步',
  'board.aria': '{game} 棋盤',
  'board.promote': '選擇升變棋子',

  'ctl.new': '新遊戲',
  'ctl.undo': '悔棋',
  'ctl.redo': '重做',
  'ctl.pause': '暫停',
  'ctl.resume': '繼續',
  'ctl.restart': '重新開始',
  'ctl.resign': '認輸',
  'ctl.draw': '提和',
  'ctl.claim': '申請和棋',
  'ctl.flip': '翻轉棋盤',
  'ctl.save': '儲存對局',
  'ctl.load': '載入對局',
  'ctl.export': '匯出棋譜',
  'ctl.hint': '提示',
  'ctl.rules': '規則說明',
  'ctl.sound': '音效',
  'ctl.anim': '動畫',
  'ctl.coach': '教練',
  'ctl.more': '更多',
  'ctl.moves': '棋步紀錄',
  'ctl.close': '關閉',
  'ctl.confirm': '確定',
  'ctl.cancel': '取消',
  'ctl.copy': '複製',
  'ctl.copied': '已複製',
  'ctl.back': '返回',

  'confirm.resign': '確定要認輸嗎？',
  'confirm.restart': '確定要重新開始嗎？目前對局將結束。',

  'end.title.win': '{side} 獲勝',
  'end.title.draw': '和局',
  'end.title.youWin': '你贏了！',
  'end.title.youLose': '你輸了',
  'end.again': '再來一局',
  'end.analyse': '賽後分析',
  'end.home': '回首頁',
  'end.rating': '積分 {old} → {new}',

  'reason.checkmate': '將死',
  'reason.stalemate': '逼和',
  'reason.stalemate_loss': '困斃（無子可動）',
  'reason.insufficient_material': '子力不足',
  'reason.fivefold_repetition': '同一局面出現五次',
  'reason.threefold_repetition': '同一局面出現三次（申請和棋）',
  'reason.seventyfive_move': '75 回合規則',
  'reason.fifty_move': '50 回合規則（申請和棋）',
  'reason.perpetual_check': '長將判負',
  'reason.perpetual_chase': '長捉判負',
  'reason.repetition': '重複局面',
  'reason.no_capture_limit': '自然限著（長時間無吃子）',
  'reason.all_captured': '棋子全部被吃光',
  'reason.no_moves': '無棋可走',
  'reason.no_progress': '長時間無吃子也無翻棋',
  'reason.resign': '認輸',
  'reason.timeout': '超時',
  'reason.timeout_draw': '超時，但對手無法取勝',
  'reason.agreement': '雙方同意和棋',
  'reason.abandon': '對手離線逾時',
  'reason.ply_cap': '步數上限',

  'clock.paused': '已暫停',

  'offer.draw.sent': '已提出和棋，等待對手回覆。',
  'offer.draw.recv': '對手提議和棋。',
  'offer.undo.sent': '已請求悔棋，等待對手同意。',
  'offer.undo.recv': '對手請求悔棋。',
  'offer.accept': '同意',
  'offer.decline': '拒絕',
  'offer.declined': '對手拒絕了請求。',
  'claim.invalid': '目前不符合申請和棋的條件。',

  'coach.title': 'AI 教練',
  'coach.hint': '建議走法：{move}',
  'coach.hint.loading': '教練思考中…',
  'coach.blunder': '這步可能是失誤：局面約損失 {cp} 分。較好的走法是 {move}。',
  'coach.mistake': '這步不是最好的選擇，可以考慮 {move}。',
  'coach.good': '好棋！',
  'coach.best': '這就是最佳著法。',
  'coach.inCheck': '你正被將軍，必須先解除。',
  'coach.empty_square': '這裡沒有棋子。',
  'coach.not_your_piece': '這不是你的棋子。',
  'coach.must_answer_check': '你正被將軍，這枚棋子無法解除將軍。',
  'coach.pinned': '這枚棋子被牽制，移動會讓國王被將軍。',
  'coach.pinned_xq': '移動這枚棋子會讓帥（將）被將軍或與對方照面。',
  'coach.horse_blocked': '馬腳被擋住了（蹩馬腿），所以不能往那個方向跳。',
  'coach.elephant_blocked': '象眼被塞住，或前方已到河界，相（象）無法移動。',
  'coach.palace_limit': '帥（將）和仕（士）不能離開九宮。',
  'coach.blocked': '這枚棋子的去路都被擋住了。',
  'coach.bq_blocked': '周圍沒有空格，也沒有可以吃的棋子。',
  'coach.bq_king_blocked': '帥（將）不能吃兵卒，周圍也沒有空格。',
  'coach.no_moves_chess': '這枚棋子目前沒有合法走法。',
  'coach.threat': '注意！你的 {piece} 正受到攻擊。',
  'coach.strategy.chess': '開局原則：控制中央、出動騎士和主教、儘早王車易位。',
  'coach.strategy.xiangqi': '開局原則：先出車、馬，架好中炮或屏風馬，保護好將帥。',
  'coach.strategy.banqi': '暗棋原則：別在敵方強子旁邊翻棋；先保護大子，善用炮的跳吃。',
  'coach.disabledRated': '計分線上對局禁止使用 AI 教練與提示。',
  'coach.analysis.title': '賽後分析',
  'coach.analysis.running': '分析中…（{n}/{total}）',
  'coach.analysis.summary': '{side}：失誤 {b} 次、不精確 {m} 次、平均損失 {acpl} 分',
  'coach.analysis.blunderAt': '第 {n} 手 {move}：失誤，較佳為 {best}',
  'coach.analysis.none': '沒有明顯失誤，下得很好！',
  'coach.analysis.banqi': '暗棋賽後分析依據雙方子力變化：',
  'coach.analysis.material': '第 {n} 手後子力差 {diff}',

  'online.connecting': "正在連線…",
  'online.connected': "已連線",
  'online.reconnecting': "連線中斷，正在重新連線。對局可能仍在進行。",
  'online.opponentLeft': '對手暫時離線，{s} 秒內未回來將判對手負。',
  'online.waiting': "等待對手加入。你可以分享房間連結邀請朋友。",
  'online.share': '分享這個邀請連結給朋友：',
  'online.code': '房間代碼',
  'online.spectator': '你正在觀戰。',
  'online.full': '房間已滿。',
  'online.notFound': "找不到房間，可能已結束或過期。請確認邀請連結。",
  'online.you': '你',
  'online.opponent': '對手',
  'online.guest': '訪客',

  'mm.title': '線上配對',
  'mm.searching': '正在尋找對手…已等待 {s} 秒',
  'mm.cancel': '取消配對',
  'mm.found': '找到對手！',
  'mm.rated.needLogin': '計分配對需要先登入 Google 帳號。',

  'auth.login': '使用 Google 登入',
  'auth.logout': '登出',
  'auth.guest': '訪客模式',
  'auth.guestNote': '不登入也能遊玩；登入後可同步紀錄與積分。',
  'auth.error': '登入失敗，請再試一次。',

  'profile.title': '玩家資料',
  'profile.nickname': '暱稱',
  'profile.save': '儲存',
  'profile.saved': '已儲存',
  'profile.rating': '積分',
  'profile.games': '對局數',
  'profile.winRate': '勝率',
  'profile.wins': '勝',
  'profile.losses': '負',
  'profile.draws': '和',
  'profile.since': '加入日期',
  'profile.nickname.invalid': '暱稱需為 2–20 個字元，可使用中英文、數字、底線與連字號。',
  'profile.loginRequired': '登入後即可查看與編輯玩家資料。',

  'history.title': '對局紀錄',
  'history.empty': '還沒有對局紀錄。',
  'history.local': '本機儲存的對局',
  'history.online': '線上對局',
  'history.open': '開啟',
  'history.delete': '刪除',
  'history.replay': '重播',
  'history.result.win': '勝',
  'history.result.loss': '負',
  'history.result.draw': '和',
  'history.vs': '對手',
  'history.date': '日期',
  'history.mode': '模式',

  'lb.title': '排行榜',
  'lb.rank': '名次',
  'lb.player': '玩家',
  'lb.rating': '積分',
  'lb.games': '對局',
  'lb.empty': '目前還沒有正式計分對局。',
  'lb.note': '只計入登入玩家之間的線上計分對局，且至少完成 5 局才會列入排行。',

  'settings.title': '網站設定',
  'settings.theme': '主題',
  'theme.system': '跟隨系統',
  'theme.light': '明亮',
  'theme.dark': '深色',
  'settings.sound': '音效',
  'settings.animation': '動畫',
  'settings.coord': '顯示座標',
  'settings.hints': '顯示合法走法提示',
  'settings.on': '開',
  'settings.off': '關',

  'learn.title': '規則教學',
  'learn.lesson': '第 {n} 課',
  'learn.prev': '上一個教學',
  'learn.next': '下一個教學',
  'learn.retry': '重新練習',
  'learn.exit': '離開教學',
  'learn.done': '完成！',
  'learn.try': '請依照指示走棋。',
  'learn.wrong': '不是這一步喔，再試一次！',
  'learn.correct': '答對了！',
  'learn.continue': '繼續',
  'learn.reference': '完整規則查詢',
  'learn.challenge': '挑戰題',
  'learn.mistakes': '常見錯誤',
  'learn.progress': '進度 {a}/{b}',
  'learn.allDone': '恭喜完成全部課程！現在就去下一盤吧。',

  'mode.ai': '電腦對戰',
  'mode.local': '雙人同機',
  'mode.online': '線上對戰',
  'mode.practice': 'AI 練習',

  'err.generic': "這次操作未完成，請稍後再試。",
  'err.network': "網路連線失敗，請檢查連線後重試。",
  'err.rateLimit': "操作太快了，請稍候再試。",
  'err.illegal': "這一步不符合規則，請選擇其他位置。",
  'err.notYourTurn': "還沒輪到你，請等待對手完成這一步。",
  'err.loadFailed': "無法讀取這份對局檔案，請確認檔案格式。",
  'err.engine': "電腦對手載入失敗，已切換為備用對手。",
  'err.notFound': "找不到這個頁面，請從首頁選擇遊戲。",

  'about.title': '關於 JY Games',
  'privacy.title': '隱私權政策',
  'terms.title': '服務條款',
  'footer.license': '原始碼以 GPL-3.0 授權公開',
  'footer.source': '原始碼',
  'game.territory': "領地爭奪戰",
  'game.territory.en': "Territory Rush",
  'game.territory.desc': "離開領地畫出軌跡，再繞回來擴大地盤。留意對手，別讓自己的軌跡被切斷！",
  'tr.mode.ai': "單人 vs 電腦",
  'tr.mode.ai.desc': "和 1–7 位電腦對手搶地盤。",
  'tr.mode.local': "雙人同機",
  'tr.mode.local.desc': "同一台裝置：WASD 對方向鍵。",
  'tr.mode.match': "線上配對",
  'tr.mode.match.desc': "自動加入 2–8 人的線上對戰。",
  'tr.mode.room': "建立私人房間",
  'tr.mode.room.desc': "邀請朋友，最多 8 人。",
  'tr.mode.learn': "玩法教學",
  'tr.mode.learn.desc': "五個步驟學會圈地與攻擊。",
  'tr.setup.bots': "電腦對手數量",
  'tr.setup.level': "電腦難度",
  'tr.setup.duration': "對局時間",
  'tr.setup.minutes': "{m} 分鐘",
  'tr.setup.start': "開始遊戲",
  'tr.setup.name1': "玩家 1",
  'tr.setup.name2': "玩家 2",
  'tr.color.mine': "你的顏色",
  'tr.color.p1': "玩家 1 的顏色",
  'tr.color.p2': "玩家 2 的顏色",
  'tr.color.chosen': "已選：{name}",
  'tr.color.taken': "{name}（{who}已選）",
  'tr.color.note': "電腦對手會用其他顏色，同一局不會撞色。你頭上的圓圈代表你自己。",
  'tr.color.onlineNote': "同一房間不會撞色：別人先選走的顏色，會換成最接近的顏色。",
  'tr.color.moved': "{want}已有人用，你的顏色改為{got}。",
  'tr.level.easy.desc': "隨意亂逛，容易被攔截，適合小朋友。",
  'tr.level.medium.desc': "會保護軌跡、挑安全的地方擴張，也會偷襲。",
  'tr.level.hard.desc': "路徑規劃、風險評估、專門攔截你的軌跡。",
  'tr.hud.land': "領地",
  'tr.hud.kills': "淘汰",
  'tr.hud.time': "剩餘時間",
  'tr.hud.rank': "排行榜",
  'tr.hud.you': "你",
  'tr.hud.bot': "電腦",
  'tr.hud.spectating': "觀戰中",
  'tr.hud.controls': "方向鍵／WASD／滑鼠／滑動",
  'tr.hud.controls2p': "玩家 1：WASD　玩家 2：方向鍵",
  'tr.hud.joystick': "虛擬搖桿",
  'tr.hud.flowMouse': "滑鼠指向哪裡，就往哪裡走",
  'tr.hud.flowTouch': "手指放在哪裡，就往哪裡走",
  'tr.hud.flow2p': "玩家 1 用左半邊、玩家 2 用右半邊：手指放在哪裡就往哪裡走（鍵盤：WASD／方向鍵）",
  'tr.hud.countdown': "準備…",
  'tr.ev.youKilled': "你淘汰了 {name}！",
  'tr.ev.killed': "{killer} 淘汰了 {name}",
  'tr.ev.died.wall': "{name} 撞到邊界",
  'tr.ev.died.self': "{name} 碰到自己的軌跡",
  'tr.ev.died.land': "{name} 的領地被吃光了",
  'tr.ev.died.collision': "{name} 正面相撞",
  'tr.ev.died.left': "{name} 離開了遊戲",
  'tr.ev.youDied': "你被淘汰了",
  'tr.end.win': "勝利！",
  'tr.end.lose': "遊戲結束",
  'tr.end.draw': "時間到",
  'tr.end.winnerIs': "{name} 獲勝",
  'tr.end.reason.last_standing': "最後的倖存者",
  'tr.end.reason.domination': "占領超過 60% 的地圖",
  'tr.end.reason.time': "時間到，領地最大者獲勝",
  'tr.end.reason.all_dead': "所有玩家都被淘汰",
  'tr.end.yourRank': "名次：第 {n} 名",
  'tr.end.yourStats': "最大領地 {pct}%・淘汰 {kills} 人・得分 {score}",
  'tr.end.again': "再玩一次",
  'tr.end.back': "返回",
  'tr.room.title': "領地爭奪戰房間",
  'tr.room.players': "玩家（{n}/8）",
  'tr.room.host': "房主",
  'tr.room.addBot': "加入電腦",
  'tr.room.removeBot': "移除",
  'tr.room.start': "開始對戰",
  'tr.room.waitHost': "等待房主開始…",
  'tr.room.needTwo': "至少需要 2 位玩家（可加入電腦）。",
  'tr.room.inProgress': "對局進行中，你正在觀戰。",
  'tr.match.searching': "正在尋找玩家…（{n} 人等待中）",
  'tr.match.note': "有 2 人以上時約 10 秒內開始；20 秒內沒有其他玩家也會直接開始。人數不足 4 人時由電腦補位。",
  'tr.lb.score': "最高得分",
  'tr.lb.wins': "勝場",
  'tr.lb.kills': "淘汰數",
  'tr.lb.bestPct': "最大占有率",
  'tr.lb.games': "場次",
  'tr.lb.note': "只計入登入玩家參與、至少 2 位真人的線上對局。",
  'tr.profile.title': "領地爭奪戰紀錄",
  'tr.learn.s1.title': "控制方向",
  'tr.learn.s1.text': "你的角色會一直往前走。滑鼠指向哪裡、手指放在哪裡，就往哪裡走；方向鍵也可以。試著轉三個大彎。",
  'tr.learn.s2.title': "圈下新領地",
  'tr.learn.s2.text': "離開自己的顏色區域後會留下一條軌跡。繞一圈回到自己的領地，軌跡圍起來的範圍就全部變成你的！試著一次圈下至少 15 格。",
  'tr.learn.s3.title': "小心自己的軌跡",
  'tr.learn.s3.text': "軌跡是你的弱點：碰到自己的軌跡、撞到邊界，或被敵人碰到軌跡，都會被淘汰。軌跡越長越危險，記得早點回家！",
  'tr.learn.s4.title': "切斷對手",
  'tr.learn.s4.text': "電腦對手正在外面畫軌跡。衝過去碰到它的軌跡，就能把它淘汰！",
  'tr.learn.s5.title': "怎樣算贏",
  'tr.learn.s5.text': "成為最後的倖存者、占領超過 60% 的地圖，或時間到時領地最大，就能獲勝。準備好就去對戰吧！",
  'tr.learn.done': "完成！",
  'tr.learn.retry': "被淘汰了，再試一次！",
  'tr.learn.progress': "已轉大彎 {n}/3 次（每次轉超過 70° 才算）",
  'tr.rules.title': "領地爭奪戰規則",
  'game.snake': "貪食蛇競技場",
  'game.snake.en': "Snake Arena",
  'game.snake.desc': "吃食物、變長，留出轉彎的空間。自己挑戰紀錄，或加入最多 8 人的競技場。",
  'game.blocks': "方塊消除對戰",
  'game.blocks.en': "Block Puzzle Battle",
  'game.sudoku.en': "Sudoku",
  'game.blocks.desc': "移動與旋轉落下的方塊，填滿整行就能消除。練習堆疊，或用消行向對手送出障礙行。",
  'home.cat.board': "棋藝策略",
  'home.cat.board.desc': "回合制・動腦思考",
  'home.cat.realtime': "即時競技",
  'home.cat.realtime.desc': "反應與走位・碰碰車・計程車",
  'home.cat.puzzle': "益智與創作",
  'home.cat.puzzle.desc': "堆疊消行・數字邏輯・混色畫畫・畫雲霄飛車",
  'home.cat.learn': "動手學數學",
  'ar.createRoom': "建立房間",
  'ar.rankedOn': "成績會由伺服器重播驗證後列入排行榜。",
  'ar.rankedLogin': "登入後，單人成績可經伺服器驗證列入排行榜（訪客成績只保存在本機）。",
  'ar.recordSaved': "成績已驗證並登錄",
  'ar.recordFailed': "成績未能登錄（驗證失敗或網路中斷）",
  'ar.statsSaved': "戰績已記錄到帳號",
  'lb.board': "排行榜類別",
  'lb.arena.note': "僅計算至少 2 位真人參與的線上對局，至少 3 場才列入。",
  'lb.solo.note': "單人成績由伺服器以相同亂數種子重播操作紀錄驗證；貪食蛇採標準設定（開放地圖、有邊界、一般速度）。",
  'lb.rating.note': "積分對戰的 Elo 積分，與棋類積分分開計算，至少 3 場才列入。",
  'lb.blocks.online': "線上戰績",
  'lb.col.score': "最高分",
  'lb.col.len': "最長蛇身",
  'lb.col.lines': "消行數",
  'lb.col.attack': "送出障礙",
  'lb.col.time': "最佳時間",
  'lb.col.plays': "遊玩次數",
  'sn.mode.classic': "經典模式",
  'sn.mode.classic.desc': "吃食物變長，撞牆或咬到自己就結束。",
  'sn.mode.survival': "生存模式",
  'sn.mode.survival.desc': "障礙物會陸續出現，速度越來越快，撐得越久分數越高。",
  'sn.mode.timeattack': "限時挑戰",
  'sn.mode.timeattack.desc': "2 分鐘內吃越多越好；撞到會扣 50 分並重新開始。",
  'sn.mode.ai': "電腦對戰",
  'sn.mode.ai.desc': "和 1–7 條電腦蛇同場競技。",
  'sn.mode.local': "雙人同機",
  'sn.mode.local.desc': "同一台裝置：WASD 對方向鍵，也可加入電腦。",
  'sn.mode.online': "線上雙人",
  'sn.mode.online.desc': "建立私人房間邀請朋友，最多 8 人。",
  'sn.mode.arena': "多人競技場",
  'sn.mode.arena.desc': "公開配對，2–8 人即時同場。",
  'sn.mode.learn': "玩法教學",
  'sn.mode.learn.desc': "五個互動步驟學會操作與對戰規則。",
  'sn.rules.title': "貪食蛇競技場規則",
  'sn.rules.r1': "蛇會持續前進，只能轉向，不能 180° 迴轉。",
  'sn.rules.r2': "吃到食物長度 +1、得 10 分；金色星星長度 +3、得 50 分，一段時間後消失。",
  'sn.rules.r3': "撞到牆壁、障礙物、自己或其他蛇的身體就會淘汰（經典模式可關閉邊界改為穿越）。",
  'sn.rules.r4': "正面相撞時較長的蛇存活，一樣長則同歸於盡。",
  'sn.rules.r5': "對戰中被淘汰的蛇會留下食物；淘汰對手（對手撞上你）可得 50 分。",
  'sn.rules.r6': "最後存活者獲勝；時間到時，存活者中最長的蛇獲勝。",
  'sn.level.easy.desc': "只會追食物，常判斷錯誤。",
  'sn.level.medium.desc': "會避開障礙並規劃安全路線。",
  'sn.level.hard.desc': "路徑搜尋、空間預測、攔截對手。",
  'sn.setup.speed': "遊戲速度",
  'sn.setup.map': "地圖",
  'sn.setup.walls': "邊界牆（關閉時可穿越邊緣）",
  'sn.setup.color': "蛇的顏色",
  'sn.setup.color1': "玩家 1 顏色",
  'sn.setup.color2': "玩家 2 顏色",
  'sn.setup.customNote': "自訂設定的成績只保存在本機最高分；標準設定（開放地圖、有邊界、一般速度）才列入排行榜。",
  'sn.speed.slow': "慢",
  'sn.speed.normal': "一般",
  'sn.speed.fast': "快",
  'sn.map.open': "開放",
  'sn.map.pillars': "石柱",
  'sn.map.cross': "十字",
  'sn.map.rooms': "四房",
  'sn.hud.len': "長度",
  'sn.hud.crashes': "撞擊",
  'sn.hud.best': "最高分 {n}",
  'sn.hud.controls': "方向鍵／WASD／滑動／虛擬方向鍵，空白鍵暫停",
  'sn.hud.dpad': "方向控制器",
  'sn.hud.pause': "暫停",
  'sn.hud.resume': "繼續",
  'sn.hud.paused': "暫停中",
  'sn.ev.gold': "{name} 吃到金星！",
  'sn.ev.died.wall': "{name} 撞牆了",
  'sn.ev.died.self': "{name} 咬到自己",
  'sn.ev.died.body': "{name} 撞到其他蛇",
  'sn.ev.died.head': "{name} 正面相撞",
  'sn.ev.died.left': "{name} 離開了遊戲",
  'sn.end.over': "遊戲結束",
  'sn.end.newBest': "新的個人最高分！",
  'sn.end.stats': "最長 {len}・吃了 {foods} 個・淘汰 {kills}",
  'sn.end.reason.last_standing': "最後的倖存者",
  'sn.end.reason.all_dead': "所有蛇都被淘汰",
  'sn.end.reason.time': "時間到",
  'sn.end.reason.crash': "撞到了",
  'sn.room.title': "貪食蛇房間",
  'sn.room.note': "把連結傳給朋友就能加入，房主可加入電腦蛇，2–8 人即可開始。",
  'sn.match.note': "有 2 人以上時約 10 秒內開始；20 秒內沒有其他玩家也會開始，不足 4 人由電腦補位。",
  'sn.learn.s1.title': "控制方向",
  'sn.learn.s1.text': "蛇會一直往前走。用方向鍵、WASD 或滑動改變方向，試著轉彎 3 次。",
  'sn.learn.s2.title': "吃食物",
  'sn.learn.s2.text': "紅色果子讓蛇變長、加分。吃到 3 個吧！",
  'sn.learn.s3.title': "別咬到自己",
  'sn.learn.s3.text': "蛇越長越難轉身。不要撞到自己的身體，長到 9 格。",
  'sn.learn.s4.title': "對戰",
  'sn.learn.s4.text': "競技場裡撞到別人的身體會被淘汰，正面相撞較長的贏。和電腦同場撐過 15 秒並吃到 2 個食物。",
  'sn.learn.s5.title': "準備好了",
  'sn.learn.s5.text': "經典、生存、限時挑戰各有排行榜；多人競技場最多 8 人同場。去挑戰吧！",
  'sn.learn.food': "已吃 {n}/3 個",
  'sn.learn.len': "目前長度 {n}/9",
  'sn.learn.secs': "已撐過 {n}/15 秒",
  'bl.mode.classic': "經典單人",
  'bl.mode.classic.desc': "從第 1 級開始，每 10 行升一級，消滿 150 行即過關。",
  'bl.mode.marathon': "無盡挑戰",
  'bl.mode.marathon.desc': "沒有終點，速度不斷加快，挑戰最高分。",
  'bl.mode.sprint': "快速消行",
  'bl.mode.sprint.desc': "用最短時間消除 40 行。",
  'bl.mode.ultra': "限時挑戰",
  'bl.mode.ultra.desc': "2 分鐘內拿到最高分。",
  'bl.mode.ai': "電腦對戰",
  'bl.mode.ai.desc': "和三級電腦即時對戰，消行送出障礙行。",
  'bl.mode.local': "雙人同機",
  'bl.mode.local.desc': "同一台鍵盤左右對戰。",
  'bl.mode.online': "線上雙人",
  'bl.mode.online.desc': "建立私人房間邀請朋友對戰。",
  'bl.mode.match': "線上配對",
  'bl.mode.match.desc': "自動配對對手；20 秒內沒人就和電腦對戰。",
  'bl.mode.ranked': "積分對戰",
  'bl.mode.ranked.desc': "登入後依積分配對，勝負影響 Elo 積分。",
  'bl.mode.learn': "玩法教學",
  'bl.mode.learn.desc': "六個互動步驟：移動、旋轉、落下、消行、Hold、四行消。",
  'bl.rules.title': "方塊消除對戰規則（JY 方塊規則 v1.0）",
  'bl.rules.r1': "7 種方塊以「7 個一組隨機」出現，可預覽接下來 5 個；每顆方塊可暫存（Hold）一次。",
  'bl.rules.r2': "旋轉採 SRS 系統與踢牆表；碰到地面後有 0.5 秒鎖定延遲，最多重置 15 次。",
  'bl.rules.r3': "計分（× 等級）：單行 100、雙行 300、三行 500、四行 800；T-Spin 單／雙／三行 800／1200／1600。",
  'bl.rules.r4': "困難消除（四行消、T-Spin 消行）連續達成時 Back-to-Back ×1.5；連續消行 Combo 每次 +50 × 等級；全消另有獎勵。",
  'bl.rules.r5': "軟降每格 1 分、硬降每格 2 分；每 10 行升一級，速度加快。",
  'bl.rules.r6': "對戰：雙行送 1、三行送 2、四行送 4、T-Spin 雙行送 4，B2B +1，Combo 另加；先抵銷自己待收的障礙行。",
  'bl.rules.r7': "障礙行在你下一次放置但未消行時從底部升起，每批有一個缺口；方塊無法出現或被推出畫面即落敗。",
  'bl.level.easy.desc': "簡單放置，不擅長高堆疊。",
  'bl.level.medium.desc': "維持平整、減少空洞、基本消行。",
  'bl.level.hard.desc': "堆疊評估、兩步預測、四行消與攻防。",
  'bl.setup.startLevel': "起始等級",
  'bl.setup.levelNote': "只有從第 1 級開始的成績會列入排行榜。",
  'bl.hud.hold': "暫存",
  'bl.hud.next': "下一個",
  'bl.hud.lines': "行",
  'bl.hud.combo': "連擊 {n}",
  'bl.hud.touch': "觸控按鈕",
  'bl.hud.controls': "←→ 移動・↓ 軟降・空白鍵 硬降・↑/X 右旋・Z 左旋・A 180°・C 暫存・Esc 暫停",
  'bl.hud.controls2p': "玩家 1：A/D 移動・S 軟降・W 旋轉・Q 左旋・E 暫存・空白鍵 硬降　玩家 2：←→・↓・↑・/ 左旋・. 暫存・Enter 硬降",
  'bl.ctl.left': "左移",
  'bl.ctl.right': "右移",
  'bl.ctl.soft': "軟降",
  'bl.ctl.hard': "硬降",
  'bl.ctl.cw': "右旋",
  'bl.ctl.ccw': "左旋",
  'bl.ctl.r180': "旋轉 180°",
  'bl.ctl.hold': "暫存",
  'bl.keys.title': "自訂按鍵與手感（DAS／ARR）",
  'bl.keys.reset': "恢復預設",
  'bl.clear.1': "單行",
  'bl.clear.2': "雙行",
  'bl.clear.3': "三行",
  'bl.clear.4': "四行消！",
  'bl.clear.pc': "全消！",
  'bl.end.cleared': "過關！",
  'bl.end.time': "時間到",
  'bl.end.draw': "平手",
  'bl.end.stats': "{lines} 行・{score} 分・{time}",
  'bl.end.bestTime': "最佳時間 {t}",
  'bl.end.reason.topout': "對手的方塊堆到頂了",
  'bl.end.reason.draw': "雙方同時落敗",
  'bl.end.reason.time': "時間上限到，送出障礙行較多者獲勝",
  'bl.room.title': "方塊對戰房間",
  'bl.room.note': "把連結傳給朋友，兩人到齊後由房主開始；也可以讓電腦當對手。",
  'bl.match.note': "有對手就立即開始；20 秒內沒有對手會改和中等電腦對戰（不計戰績）。",
  'bl.ranked.login': "積分對戰需要使用 Google 帳號登入。",
  'bl.ranked.note': "你的積分：{r}。會優先配對積分相近的玩家，等待越久範圍越大。",
  'bl.learn.s1.title': "移動與旋轉",
  'bl.learn.s1.text': "用 ←→ 移動方塊，↑ 或 X 旋轉。試著移動並旋轉幾次。",
  'bl.learn.s2.title': "硬降與影子",
  'bl.learn.s2.text': "虛線框是方塊會落下的位置。按空白鍵立即落下，放下 3 顆方塊。",
  'bl.learn.s3.title': "消除一整行",
  'bl.learn.s3.text': "把 T 方塊直接落進缺口，填滿整行就會消除。",
  'bl.learn.s4.title': "暫存（Hold）",
  'bl.learn.s4.text': "按 C 或 Shift 把目前方塊存起來，需要時再換出來。試一次！",
  'bl.learn.s5.title': "四行消",
  'bl.learn.s5.text': "把長條方塊轉成直的，移到最右邊的深井裡，一次消除 4 行！",
  'bl.learn.s6.title': "對戰規則",
  'bl.learn.s6.text': "對戰時消行會送障礙行給對手，連續的四行消、T-Spin 與連擊威力更大。對方堆到頂就獲勝！",
  'onboarding.chess': "目標是將死對方國王。先選自己的棋子，再選可走的位置；不確定時，可以先進入教學。",
  'onboarding.xiangqi': "紅方先走。點選棋子查看可走的位置，進攻時也別忘了保護將帥。無合法著法的一方會輸。",
  'onboarding.banqi': "先手第一步翻開的顏色，就是先手的陣營。每回合選擇翻棋、移動或吃子；炮吃子要隔一枚棋子。",
  'onboarding.territory': "離開自己的領地畫出軌跡，再安全繞回來就能圈地。先試一個小圈，留意自己的軌跡。",
  'onboarding.snake': "轉向吃到食物，讓蛇慢慢變長。別急著搶食，先留出安全的路；碰撞規則依目前模式顯示。",
  'onboarding.blocks': "先看落點，再移動或旋轉方塊。填滿整行就會消除；硬降會立即把方塊放到底部，按下前先確認。",
  'online.syncing': "已連線，正在同步對局…",
  'online.synced': "對局已同步。",
  'online.reconnectFailed': "暫時無法恢復連線。請再次嘗試，或離開房間；對局依原規則繼續。",
  'rules.xiangqi.version': "JY Games 台灣象棋規則 v1.0",
  'rules.xiangqi.summary': "同一局面與輪走方第三次出現時，先判長將，再判簡化長捉，其餘依規則判和。完整條件與判例請見規則說明。",
  'rules.banqi.summary': "台灣常見版：炮可移動一格，隔一子吃棋；兵可吃帥、帥不可吃兵；連吃關閉。連續 50 步無吃子也無翻棋則和局，單方一次動作算一步。",
  'tutorial.actionDone': "做到了！觀察盤面如何改變，再繼續下一步。",
  'tutorial.tryAgain': "還沒完成這一步，看看提示再試一次。",
  'tutorial.finish': "練習完成！可以再試一次，或開始一局。",
  'onb.title': "開始之前",
  'onb.dismiss': "知道了",
  'onb.show': "遊戲說明",
  'online.retry': "再試一次",
  'online.leave': "離開房間",
  'online.away': "離線中",
  "game.sudoku": "數獨",
  "game.sudoku.desc": "在 9×9 方格中，找出每個數字的位置。",
  "sudoku.title": "經典數獨",
  "sudoku.subtitle": "單人・邏輯",
  "sudoku.rules": "在空格填入 1–9，讓每列、每行與每個 3×3 宮的數字都不重複。題目數字不能更改。",
  "sudoku.rules.short": "每列、每行、每宮，1–9 不重複",
  "sudoku.difficulty": "選擇難度",
  "sudoku.level": "難度",
  "sudoku.easy": "簡單",
  "sudoku.medium": "中等",
  "sudoku.hard": "困難",
  "sudoku.easy.desc": "從單一候選與唯一位置開始。",
  "sudoku.medium.desc": "練習候選排除與數字配對。",
  "sudoku.hard.desc": "挑戰隱性配對與 X-Wing。",
  "sudoku.start": "開始遊戲",
  "sudoku.continue": "繼續遊戲",
  "sudoku.new": "新遊戲",
  "sudoku.more": "更多",
  "sudoku.undo": "復原",
  "sudoku.erase": "清除",
  "sudoku.notes.on": "筆記：開",
  "sudoku.notes.off": "筆記：關",
  "sudoku.notes.help": "點數字可加入或移除候選筆記。筆記不算填答。",
  "sudoku.notes.filled": "先清除填答，才能在這一格做筆記。",
  "sudoku.hint": "提示",
  "sudoku.hint.title": "下一步的線索",
  "sudoku.hint.apply": "幫我填入",
  "sudoku.hint.eliminate": "套用候選排除",
  "sudoku.hint.close": "我自己試試",
  "sudoku.hint.count": "提示次數：{count}",
  "sudoku.hint.conflict": "先處理重複的數字，再取得下一步提示。",
  "sudoku.hint.contradiction": "第 {row} 列第 {column} 行的填答，使這一題無法完成。你可以清除後重新推理。",
  "sudoku.hint.unavailable": "暫時無法提供下一步提示。進度已保留，請再試一次。",
  "sudoku.hint.nakedSingle": "排除同列、同行與同宮已出現的數字後，第 {row} 列第 {column} 行只剩 {digit} 可以填。",
  "sudoku.hint.hiddenSingle": "{unit}中，只有第 {row} 列第 {column} 行能填入 {digit}。",
  "sudoku.hint.locked": "{sourceUnit}中的 {digit} 只能出現在{cells}，因此可從{targetCells}排除 {digit}。",
  "sudoku.hint.nakedPair": "{unit}中的{cells}都只剩 {digits}，這兩個數字必須占據這兩格，可從{targetCells}排除。",
  "sudoku.hint.hiddenPair": "{unit}中的 {digits} 都只能出現在{cells}，因此這兩格可移除其他候選。",
  "sudoku.hint.xwing": "{sourceUnits}中的 {digit} 都只能落在{crossUnits}的交點，因此可從{targetCells}排除 {digit}。",
  "sudoku.pause": "暫停",
  "sudoku.paused.title": "休息一下",
  "sudoku.paused.desc": "棋盤與計時已暫停",
  "sudoku.resume": "繼續遊戲",
  "sudoku.zoom": "放大九宮",
  "sudoku.overview": "完整棋盤",
  "sudoku.box.choose": "選擇九宮",
  "sudoku.row": "第 {number} 列",
  "sudoku.column": "第 {number} 行",
  "sudoku.box": "第 {number} 宮",
  "sudoku.selection": "第 {row} 列 · 第 {column} 行",
  "sudoku.select.help": "先選一格，再填入數字。",
  "sudoku.given.locked": "這是題目數字，請選擇空白格。",
  "sudoku.conflict": "有數字重複，請查看標示的格子。",
  "sudoku.restart": "重新開始",
  "sudoku.restart.title": "重新開始這一題？",
  "sudoku.restart.desc": "填答、筆記與計時將重新開始，完成紀錄會標記為重玩。",
  "sudoku.new.title": "開始新的一題？",
  "sudoku.new.desc": "目前這一局的進度會被取代。",
  "sudoku.cancel": "繼續這一局",
  "sudoku.saved": "已儲存在此瀏覽器",
  "sudoku.save.failed": "無法儲存，離開後可能遺失進度。",
  "sudoku.save.invalid": "無法讀取這份進度。原始資料已保留，你可以開始新遊戲。",
  "sudoku.otherTab": "這一局已在另一個分頁開啟，這裡已暫停。",
  "sudoku.complete": "完成了！",
  "sudoku.time": "遊玩時間",
  "sudoku.assisted": "使用過提示",
  "sudoku.unassisted": "未使用提示",
  "sudoku.replayed": "重玩",
  "sudoku.next": "再玩一題",
  "sudoku.viewBoard": "查看棋盤",
  "sudoku.back": "返回大廳",
  "sudoku.history": "最近完成紀錄",
  "sudoku.history.local": "紀錄只儲存在此瀏覽器，不會同步到其他裝置。",
  "sudoku.teach.row": "每一列都要有 1–9，而且不能重複。",
  "sudoku.teach.column": "直向的每一行，也要有 1–9。",
  "sudoku.teach.box": "每個粗線框出的 3×3 宮，都要有 1–9。",
  "sudoku.teach.single": "看看同列、同行與同宮，找出這一格唯一能填的數字。",
  "sudoku.teach.notes": "還不確定時，開啟筆記記下候選；需要幫忙時，提示會解釋下一步。",
  "sudoku.teach.success": "答對了，繼續下一步。",
  "sudoku.teach.retry": "再看看相關的列、行與九宮。",
  "sudoku.a11y.grid": "數獨棋盤",
  "sudoku.a11y.keypad": "數字鍵盤",
  "sudoku.a11y.cell": "第 {row} 列，第 {column} 行，第 {box} 宮；{content}；{state}",
  "sudoku.a11y.empty": "空白",
  "sudoku.a11y.given": "題目",
  "sudoku.a11y.entry": "填答",
  "sudoku.a11y.notes": "筆記 {digits}",
  "sudoku.a11y.conflict": "重複數字",
  "sudoku.saving.none": "尚未儲存",
  "sudoku.records.empty": "還沒有完成紀錄。",
  "sudoku.hints": "提示",
  "sudoku.learn": "規則教學",
  "sudoku.selectBox": "第 {number} 宮",
  "sudoku.restart.confirm": "重新開始",
  "sudoku.new.confirm": "開始新題",
  "sudoku.teach.title": "數獨教學",
  "sudoku.teach.next": "下一步",
  "sudoku.teach.done": "教學完成！開始玩一題吧。",
  "sudoku.teach.toggleNotes": "請開啟筆記，在這一格記下候選。",
  "sudoku.giveUp": "放棄存檔",
  'footer.copyright': '© {y} JetNet Ltd.',
};

export type StringKey = keyof typeof zh;

export const en: Record<StringKey, string> = {
  'app.name': 'JY Games',
  'app.tagline': "Play Together, Think Better.",
  'nav.home': 'Home',
  'nav.play': 'Play',
  'nav.learn': 'Learn',
  'nav.leaderboard': 'Leaderboard',
  'nav.history': 'History',
  'nav.profile': 'Profile',
  'nav.settings': 'Settings',
  'nav.about': 'About',
  'nav.privacy': 'Privacy',
  'nav.terms': 'Terms',
  'nav.menu': 'Menu',
  'nav.skip': 'Skip to main content',
  // home & shared UI v1 (docs/design/home-shared-ui-v1/copy.json)
  'home.v2.intro': "Choose a game, then choose how to play.",
  'home.v2.play': "Play",
  'home.v2.rules': "How to play",
  'home.v2.playLabel': "Play: {game}",
  'home.v2.rulesLabel': "How to play: {game}",
  'home.v2.chess.desc': "Protect your king and checkmate your opponent.",
  'home.v2.xiangqi.desc': "Move your pieces to checkmate the general.",
  'home.v2.banqi.desc': "Flip pieces, plan moves and capture.",
  'home.v2.territory.desc': "Draw a trail and return home to claim land.",
  'home.v2.snake.desc': "Eat to grow. Watch out for collisions.",
  'home.v2.blocks.desc': "Move and rotate blocks to clear full rows.",
  'home.v2.sudoku.desc': "Fill in 1–9 without repeats in rows, columns or boxes.",
  'home.v2.doodle.desc': "Mix colours and make your own picture.",
  'game.doodle': "Color Doodle",
  'game.coaster': "Sketch Coaster",
  'game.bumper': "Crazy Bumper",
  'home.v2.bumper.desc': "Pick an animal, jump in a bumper car and bump out the most stars in 60 seconds.",
  'game.taxi': "Rush Taxi",
  'home.v2.taxi.desc': "Drive a taxi round a harbour city: pick up riders, drift, dash and earn the most fares before time runs out.",
  'home.v2.coaster.desc': "Draw a line, then ride it in first person.",
  'game.math': "Math Island",
  'home.v2.math.desc': "Apple Basket (grade 1) and Packing Factory (grade 3): move things, then count. Questions are in Chinese for now.",
  'game.doodle.en': "Drawing and colour mixing",
  'game.doodle.desc': "Start drawing right away, mix red, yellow, blue, white and black into 24 more colours on the palette, try short tasks and save your picture.",
  'nav.allGames': "All games",
  'nav.primaryLabel': "Main navigation",
  'nav.menuLabel': "Site navigation",
  'nav.openMenu': "Open menu",
  'nav.closeMenu': "Close menu",
  'theme.changeLabel': "Current: {current}; switch to: {next}",
  'common.loadingLabel': "Loading",
  'nav.group.games': "Games",
  'nav.group.more': "More",
  'nav.group.account': "Account",
  'lang.switch': '繁體中文',
  'lang.label': 'Language',

  'game.chess': 'Chess',
  'game.xiangqi': 'Xiangqi',
  'game.banqi': 'Banqi',
  'game.chess.en': 'Chess',
  'game.xiangqi.en': 'Chinese Chess',
  'game.banqi.en': 'Taiwanese Dark Chess',
  'game.chess.desc': "Protect your king and checkmate your opponent. Learn the basic moves, then build your attacking and defensive skills.",
  'game.xiangqi.desc': "Plan your attack with chariots, horses and cannons. Uses our published rules, including simplified perpetual-check and chase decisions.",
  'game.banqi.desc': "Flip a piece, read the board, then choose whether to move or capture. Taiwan rules are the default; check the full rules before playing.",

  'home.hero.title': 'Seven great games. One real-time showdown.',
  'home.hero.sub': "Explore board games, real-time arenas and block puzzles. Practise solo, share a device with family, or invite friends online. New here? Start with a tutorial.",
  'home.cta.play': 'Play now',
  'home.cta.learn': 'Learn the rules',
  'home.features.ai': 'Three AI levels',
  'home.features.ai.desc': 'Easy, Medium and Hard with clearly different strength — for kids and experts alike.',
  'home.features.online': 'Real-time online play',
  'home.features.online.desc': "Create a room for friends or find an opponent through matchmaking.",
  'home.features.learn': 'Interactive lessons',
  'home.features.learn.desc': 'Learn by doing — make the requested move to unlock the next step.',
  'home.features.coach': 'AI coach',
  'home.features.coach.desc': 'Hints, blunder alerts and post-game review, all grounded in engine analysis.',

  'hub.vsAi': 'Play the computer',
  'hub.vsAi.desc': 'Pick a level and practise anytime.',
  'hub.local': 'Two players, one device',
  'hub.local.desc': 'Take turns on the same screen.',
  'hub.match': 'Online matchmaking',
  'hub.match.desc': 'Find an opponent automatically.',
  'hub.room': 'Create a private room',
  'hub.room.desc': 'Get an invite link for a friend.',
  'hub.learn': 'Learn the rules',
  'hub.learn.desc': 'Hands-on lessons from the very first piece.',
  'hub.practice': 'AI practice',
  'hub.practice.desc': 'Coach on, hints and take-backs allowed.',
  'hub.join': 'Enter a room code',
  'hub.join.btn': 'Join',

  'setup.title': 'Game setup',
  'setup.level': 'Computer level',
  'level.easy': 'Easy',
  'level.medium': 'Medium',
  'level.hard': 'Hard',
  'level.easy.desc': 'For children and beginners — makes mistakes.',
  'level.medium.desc': 'Solid basics, attacks and defends.',
  'level.hard.desc': 'Deep search for experienced players.',
  'setup.side': 'I play',
  'side.first': 'First',
  'side.second': 'Second',
  'side.random': 'Random',
  'side.white': 'White',
  'side.black': 'Black',
  'side.red': 'Red',
  'side.blackXq': 'Black',
  'setup.time': 'Time control',
  'setup.time.none': 'Untimed',
  'setup.time.fmt': '{m} min + {s} s',
  'setup.allowUndo': 'Allow take-backs',
  'setup.coach': 'Turn on AI coach',
  'setup.rules': 'Banqi rules',
  'setup.rated': 'Rated game',
  'setup.rated.desc': 'Requires sign-in; affects your rating.',
  'setup.start': 'Start game',
  'preset.taiwan': 'Taiwan standard',
  'preset.taiwan_chain': 'Taiwan + chain captures',
  'preset.strict_rank': 'Strict rank',

  'board.turn': '{side} to move',
  'board.yourTurn': 'Your move',
  'board.thinking': 'Computer is thinking…',
  'board.check': 'Check!',
  'board.checkChess': 'Check!',
  'board.flip': 'Flip',
  'board.hidden': 'Face-down piece',
  'board.empty': 'Empty',
  'board.square': '{sq}',
  'board.legalHint': 'Legal destination',
  'board.lastMove': 'Last move',
  'board.aria': '{game} board',
  'board.promote': 'Choose a promotion piece',

  'ctl.new': 'New game',
  'ctl.undo': 'Undo',
  'ctl.redo': 'Redo',
  'ctl.pause': 'Pause',
  'ctl.resume': 'Resume',
  'ctl.restart': 'Restart',
  'ctl.resign': 'Resign',
  'ctl.draw': 'Offer draw',
  'ctl.claim': 'Claim draw',
  'ctl.flip': 'Flip board',
  'ctl.save': 'Save game',
  'ctl.load': 'Load game',
  'ctl.export': 'Export notation',
  'ctl.hint': 'Hint',
  'ctl.rules': 'Rules',
  'ctl.sound': 'Sound',
  'ctl.anim': 'Animation',
  'ctl.coach': 'Coach',
  'ctl.more': 'More',
  'ctl.moves': 'Moves',
  'ctl.close': 'Close',
  'ctl.confirm': 'OK',
  'ctl.cancel': 'Cancel',
  'ctl.copy': 'Copy',
  'ctl.copied': 'Copied',
  'ctl.back': 'Back',

  'confirm.resign': 'Resign this game?',
  'confirm.restart': 'Restart? The current game will end.',

  'end.title.win': '{side} wins',
  'end.title.draw': 'Draw',
  'end.title.youWin': 'You win!',
  'end.title.youLose': 'You lost',
  'end.again': 'Play again',
  'end.analyse': 'Review game',
  'end.home': 'Home',
  'end.rating': 'Rating {old} → {new}',

  'reason.checkmate': 'Checkmate',
  'reason.stalemate': 'Stalemate',
  'reason.stalemate_loss': 'No legal moves (stalemate loses in xiangqi)',
  'reason.insufficient_material': 'Insufficient material',
  'reason.fivefold_repetition': 'Fivefold repetition',
  'reason.threefold_repetition': 'Threefold repetition (claimed)',
  'reason.seventyfive_move': '75-move rule',
  'reason.fifty_move': '50-move rule (claimed)',
  'reason.perpetual_check': 'Perpetual check loses',
  'reason.perpetual_chase': 'Perpetual chase loses',
  'reason.repetition': 'Repetition',
  'reason.no_capture_limit': 'Move limit without captures',
  'reason.all_captured': 'All pieces captured',
  'reason.no_moves': 'No moves left',
  'reason.no_progress': 'No capture or flip for too long',
  'reason.resign': 'Resignation',
  'reason.timeout': 'Time out',
  'reason.timeout_draw': 'Time out, but the opponent cannot win',
  'reason.agreement': 'Draw agreed',
  'reason.abandon': 'Opponent left the game',
  'reason.ply_cap': 'Move cap',

  'clock.paused': 'Paused',

  'offer.draw.sent': 'Draw offered — waiting for your opponent.',
  'offer.draw.recv': 'Your opponent offers a draw.',
  'offer.undo.sent': 'Take-back requested — waiting for your opponent.',
  'offer.undo.recv': 'Your opponent asks to take back a move.',
  'offer.accept': 'Accept',
  'offer.decline': 'Decline',
  'offer.declined': 'Your opponent declined.',
  'claim.invalid': 'A draw cannot be claimed in this position.',

  'coach.title': 'AI coach',
  'coach.hint': 'Suggested move: {move}',
  'coach.hint.loading': 'Coach is thinking…',
  'coach.blunder': 'That may be a blunder — about {cp} points lost. {move} was better.',
  'coach.mistake': 'Not the best choice; consider {move}.',
  'coach.good': 'Good move!',
  'coach.best': 'That is the best move.',
  'coach.inCheck': 'You are in check and must get out of it.',
  'coach.empty_square': 'There is no piece here.',
  'coach.not_your_piece': 'That is not your piece.',
  'coach.must_answer_check': 'You are in check, and this piece cannot stop it.',
  'coach.pinned': 'This piece is pinned — moving it would expose your king.',
  'coach.pinned_xq': 'Moving this piece would put your general in check or face the other general.',
  'coach.horse_blocked': 'The horse’s leg is blocked, so it cannot jump that way.',
  'coach.elephant_blocked': 'The elephant’s eye is blocked or the river is in the way.',
  'coach.palace_limit': 'The general and advisors cannot leave the palace.',
  'coach.blocked': 'Every path for this piece is blocked.',
  'coach.bq_blocked': 'No empty square next to it and nothing it may capture.',
  'coach.bq_king_blocked': 'The general may not capture soldiers, and there is no empty square nearby.',
  'coach.no_moves_chess': 'This piece has no legal moves right now.',
  'coach.threat': 'Careful! Your {piece} is under attack.',
  'coach.strategy.chess': 'Opening tips: control the centre, develop knights and bishops, castle early.',
  'coach.strategy.xiangqi': 'Opening tips: bring out chariots and horses early, set up a central cannon or screen horses, keep the general safe.',
  'coach.strategy.banqi': 'Banqi tips: don’t flip next to strong enemy pieces; protect your big pieces; use cannon jumps.',
  'coach.disabledRated': 'The AI coach and hints are disabled in rated online games.',
  'coach.analysis.title': 'Game review',
  'coach.analysis.running': 'Analysing… ({n}/{total})',
  'coach.analysis.summary': '{side}: {b} blunders, {m} inaccuracies, average loss {acpl}',
  'coach.analysis.blunderAt': 'Move {n} {move}: blunder, {best} was better',
  'coach.analysis.none': 'No clear blunders — well played!',
  'coach.analysis.banqi': 'Banqi review is based on material swings:',
  'coach.analysis.material': 'After move {n}: material difference {diff}',

  'online.connecting': "Connecting…",
  'online.connected': "Connected",
  'online.reconnecting': "Connection lost. Reconnecting… The match may still be running.",
  'online.opponentLeft': 'Opponent disconnected. They lose if not back within {s} s.',
  'online.waiting': "Waiting for an opponent. Share the room link to invite a friend.",
  'online.share': 'Share this invite link with a friend:',
  'online.code': 'Room code',
  'online.spectator': 'You are spectating.',
  'online.full': 'This room is full.',
  'online.notFound': "Room not found. It may have ended or expired. Check your invite link.",
  'online.you': 'You',
  'online.opponent': 'Opponent',
  'online.guest': 'Guest',

  'mm.title': 'Matchmaking',
  'mm.searching': 'Looking for an opponent… {s}s',
  'mm.cancel': 'Cancel',
  'mm.found': 'Opponent found!',
  'mm.rated.needLogin': 'Rated matchmaking requires signing in with Google.',

  'auth.login': 'Sign in with Google',
  'auth.logout': 'Sign out',
  'auth.guest': 'Guest mode',
  'auth.guestNote': 'Play without an account; sign in to sync history and ratings.',
  'auth.error': 'Sign-in failed. Please try again.',

  'profile.title': 'Profile',
  'profile.nickname': 'Nickname',
  'profile.save': 'Save',
  'profile.saved': 'Saved',
  'profile.rating': 'Rating',
  'profile.games': 'Games',
  'profile.winRate': 'Win rate',
  'profile.wins': 'W',
  'profile.losses': 'L',
  'profile.draws': 'D',
  'profile.since': 'Joined',
  'profile.nickname.invalid': 'Nickname must be 2–20 characters: letters, CJK, digits, underscore or hyphen.',
  'profile.loginRequired': 'Sign in to view and edit your profile.',

  'history.title': 'Game history',
  'history.empty': 'No games yet.',
  'history.local': 'Saved on this device',
  'history.online': 'Online games',
  'history.open': 'Open',
  'history.delete': 'Delete',
  'history.replay': 'Replay',
  'history.result.win': 'Won',
  'history.result.loss': 'Lost',
  'history.result.draw': 'Draw',
  'history.vs': 'Opponent',
  'history.date': 'Date',
  'history.mode': 'Mode',

  'lb.title': 'Leaderboard',
  'lb.rank': 'Rank',
  'lb.player': 'Player',
  'lb.rating': 'Rating',
  'lb.games': 'Games',
  'lb.empty': 'No rated games yet.',
  'lb.note': 'Only rated online games between signed-in players count; at least 5 games are needed to be listed.',

  'settings.title': 'Settings',
  'settings.theme': 'Theme',
  'theme.system': 'System',
  'theme.light': 'Light',
  'theme.dark': 'Dark',
  'settings.sound': 'Sound',
  'settings.animation': 'Animation',
  'settings.coord': 'Show coordinates',
  'settings.hints': 'Show legal move hints',
  'settings.on': 'On',
  'settings.off': 'Off',

  'learn.title': 'Learn the rules',
  'learn.lesson': 'Lesson {n}',
  'learn.prev': 'Previous lesson',
  'learn.next': 'Next lesson',
  'learn.retry': 'Try again',
  'learn.exit': 'Exit lessons',
  'learn.done': 'Done!',
  'learn.try': 'Make the move described above.',
  'learn.wrong': 'Not that one — try again!',
  'learn.correct': 'Correct!',
  'learn.continue': 'Continue',
  'learn.reference': 'Full rules reference',
  'learn.challenge': 'Challenge',
  'learn.mistakes': 'Common mistakes',
  'learn.progress': 'Progress {a}/{b}',
  'learn.allDone': 'You finished every lesson! Time to play a real game.',

  'mode.ai': 'vs Computer',
  'mode.local': 'Same device',
  'mode.online': 'Online',
  'mode.practice': 'AI practice',

  'err.generic': "That action could not be completed. Please try again shortly.",
  'err.network': "Connection failed. Check your network and try again.",
  'err.rateLimit': "Too many actions at once. Please wait a moment and try again.",
  'err.illegal': "That move is not allowed. Choose another square.",
  'err.notYourTurn': "It is not your turn yet. Wait for your opponent to move.",
  'err.loadFailed': "This game file could not be read. Check the file format.",
  'err.engine': "The computer opponent could not load. A backup opponent is now in use.",
  'err.notFound': "Page not found. Choose a game from the home page.",

  'about.title': 'About JY Games',
  'privacy.title': 'Privacy Policy',
  'terms.title': 'Terms of Service',
  'footer.license': 'Source code published under GPL-3.0',
  'footer.source': 'Source',
  'game.territory': "Territory Rush",
  'game.territory.en': "Real-time land grab",
  'game.territory.desc': "Leave your land, draw a trail and return to claim more territory. Watch your rivals: an exposed trail can be cut!",
  'tr.mode.ai': "Solo vs computer",
  'tr.mode.ai.desc': "Race 1–7 computer rivals for land.",
  'tr.mode.local': "Two players, one device",
  'tr.mode.local.desc': "Same screen: WASD vs arrow keys.",
  'tr.mode.match': "Online matchmaking",
  'tr.mode.match.desc': "Jump into a 2–8 player online match.",
  'tr.mode.room': "Create a private room",
  'tr.mode.room.desc': "Invite friends, up to 8 players.",
  'tr.mode.learn': "How to play",
  'tr.mode.learn.desc': "Five quick steps: claim land and attack.",
  'tr.setup.bots': "Computer rivals",
  'tr.setup.level': "Computer level",
  'tr.setup.duration': "Match length",
  'tr.setup.minutes': "{m} min",
  'tr.setup.start': "Start",
  'tr.setup.name1': "Player 1",
  'tr.setup.name2': "Player 2",
  'tr.color.mine': "Your colour",
  'tr.color.p1': "Player 1 colour",
  'tr.color.p2': "Player 2 colour",
  'tr.color.chosen': "Chosen: {name}",
  'tr.color.taken': "{name} (taken by {who})",
  'tr.color.note': "Computer rivals use other colours, so no two players match. The ring around a runner marks you.",
  'tr.color.onlineNote': "No two players in a room share a colour. If someone took yours first, you get the nearest free one.",
  'tr.color.moved': "{want} was taken, so your colour is {got}.",
  'tr.level.easy.desc': "Wanders around and is easy to cut off — great for kids.",
  'tr.level.medium.desc': "Guards its trail, expands where it is safe and sometimes attacks.",
  'tr.level.hard.desc': "Plans routes, weighs risk and hunts for your trail.",
  'tr.hud.land': "Land",
  'tr.hud.kills': "Knockouts",
  'tr.hud.time': "Time left",
  'tr.hud.rank': "Leaderboard",
  'tr.hud.you': "You",
  'tr.hud.bot': "CPU",
  'tr.hud.spectating': "Spectating",
  'tr.hud.controls': "Arrows / WASD / mouse / swipe",
  'tr.hud.controls2p': "Player 1: WASD   Player 2: arrow keys",
  'tr.hud.joystick': "Virtual joystick",
  'tr.hud.flowMouse': "Point to steer",
  'tr.hud.flowTouch': "Put your finger where you want to go",
  'tr.hud.flow2p': "Player 1 on the left half, player 2 on the right: put a finger where you want to go (keys: WASD / arrows)",
  'tr.hud.countdown': "Get ready…",
  'tr.ev.youKilled': "You knocked out {name}!",
  'tr.ev.killed': "{killer} knocked out {name}",
  'tr.ev.died.wall': "{name} hit the edge",
  'tr.ev.died.self': "{name} ran into their own trail",
  'tr.ev.died.land': "{name} lost all their land",
  'tr.ev.died.collision': "{name} crashed head-on",
  'tr.ev.died.left': "{name} left the game",
  'tr.ev.youDied': "You were knocked out",
  'tr.end.win': "Victory!",
  'tr.end.lose': "Game over",
  'tr.end.draw': "Time’s up",
  'tr.end.winnerIs': "{name} wins",
  'tr.end.reason.last_standing': "Last one standing",
  'tr.end.reason.domination': "Owns over 60% of the map",
  'tr.end.reason.time': "Time’s up — most land wins",
  'tr.end.reason.all_dead': "Everyone was knocked out",
  'tr.end.yourRank': "Rank: #{n}",
  'tr.end.yourStats': "Best land {pct}% · {kills} knockouts · score {score}",
  'tr.end.again': "Play again",
  'tr.end.back': "Back",
  'tr.room.title': "Territory Rush room",
  'tr.room.players': "Players ({n}/8)",
  'tr.room.host': "Host",
  'tr.room.addBot': "Add computer",
  'tr.room.removeBot': "Remove",
  'tr.room.start': "Start match",
  'tr.room.waitHost': "Waiting for the host to start…",
  'tr.room.needTwo': "At least 2 players are needed (computers count).",
  'tr.room.inProgress': "A match is in progress — you are spectating.",
  'tr.match.searching': "Looking for players… ({n} waiting)",
  'tr.match.note': "With 2+ players the match starts within about 10 s; if nobody else joins within 20 s it starts anyway. Computers fill up to 4 players.",
  'tr.lb.score': "Best score",
  'tr.lb.wins': "Wins",
  'tr.lb.kills': "Knockouts",
  'tr.lb.bestPct': "Best land %",
  'tr.lb.games': "Games",
  'tr.lb.note': "Only online matches with at least 2 signed-in humans count.",
  'tr.profile.title': "Territory Rush stats",
  'tr.learn.s1.title': "Steering",
  'tr.learn.s1.text': "Your runner never stops. Point the mouse or put your finger where you want to go; arrow keys work too. Make three big turns.",
  'tr.learn.s2.title': "Claim new land",
  'tr.learn.s2.text': "Outside your colour you leave a trail. Loop back into your land and everything the trail encloses becomes yours! Claim at least 15 cells in one go.",
  'tr.learn.s3.title': "Mind your trail",
  'tr.learn.s3.text': "Your trail is your weak spot: touching it yourself, hitting the edge, or an enemy touching it knocks you out. The longer the trail, the riskier — head home early!",
  'tr.learn.s4.title': "Cut off a rival",
  'tr.learn.s4.text': "A computer rival is out drawing a trail. Run into its trail to knock it out!",
  'tr.learn.s5.title': "How to win",
  'tr.learn.s5.text': "Be the last one standing, own more than 60% of the map, or have the most land when time runs out. Now go play!",
  'tr.learn.done': "Done!",
  'tr.learn.retry': "Knocked out — try again!",
  'tr.learn.progress': "Big turns: {n}/3 (each more than 70°)",
  'tr.rules.title': "Territory Rush rules",
  'game.snake': "Snake Arena",
  'game.snake.en': "Classic & multiplayer",
  'game.snake.desc': "Eat, grow and leave room to turn. Chase your own best score or enter an arena with up to 8 players.",
  'game.blocks': "Block Puzzle Battle",
  'game.blocks.en': "Falling-block battles",
  'game.sudoku.en': "Classic 9×9 logic",
  'game.blocks.desc': "Move and rotate falling blocks to fill and clear rows. Practise stacking or clear rows to send obstacles to your opponent.",
  'home.cat.board': "Strategy board games",
  'home.cat.board.desc': "Turn-based thinking",
  'home.cat.realtime': "Real-time action",
  'home.cat.realtime.desc': "Reflexes and positioning",
  'home.cat.puzzle': "Puzzles & creativity",
  'home.cat.puzzle.desc': "Stack, clear, reason and paint",
  'home.cat.learn': "Hands-on maths",
  'ar.createRoom': "Create room",
  'ar.rankedOn': "Your result will be verified by a server replay and added to the leaderboard.",
  'ar.rankedLogin': "Sign in to submit verified solo records (guest results are kept on this device only).",
  'ar.recordSaved': "Result verified and recorded",
  'ar.recordFailed': "Result not recorded (verification failed or network error)",
  'ar.statsSaved': "Stats saved to your account",
  'lb.board': "Board",
  'lb.arena.note': "Online matches with at least 2 human players; at least 3 games to be listed.",
  'lb.solo.note': "Solo records are verified by replaying your inputs from the server’s seed; Snake uses the standard settings (open map, walls, normal speed).",
  'lb.rating.note': "Ranked battle Elo, separate from the board-game ratings; at least 3 games to be listed.",
  'lb.blocks.online': "Online stats",
  'lb.col.score': "Best score",
  'lb.col.len': "Longest",
  'lb.col.lines': "Lines",
  'lb.col.attack': "Garbage sent",
  'lb.col.time': "Best time",
  'lb.col.plays': "Plays",
  'sn.mode.classic': "Classic",
  'sn.mode.classic.desc': "Eat to grow; hitting a wall or yourself ends the game.",
  'sn.mode.survival': "Survival",
  'sn.mode.survival.desc': "Obstacles keep appearing and the speed keeps rising — last as long as you can.",
  'sn.mode.timeattack': "Time Attack",
  'sn.mode.timeattack.desc': "Eat as much as you can in 2 minutes; a crash costs 50 points and restarts you.",
  'sn.mode.ai': "VS Computer",
  'sn.mode.ai.desc': "Share the arena with 1–7 computer snakes.",
  'sn.mode.local': "Local VS",
  'sn.mode.local.desc': "Two players on one device: WASD vs arrow keys, computers optional.",
  'sn.mode.online': "Online VS",
  'sn.mode.online.desc': "Create a private room and invite friends (up to 8).",
  'sn.mode.arena': "Multiplayer Arena",
  'sn.mode.arena.desc': "Public matchmaking, 2–8 players in real time.",
  'sn.mode.learn': "Tutorial",
  'sn.mode.learn.desc': "Five interactive steps: controls and versus rules.",
  'sn.rules.title': "Snake Arena rules",
  'sn.rules.r1': "Your snake keeps moving; you can turn but not reverse.",
  'sn.rules.r2': "Food: +1 length, 10 points. Gold star: +3 length, 50 points, disappears after a while.",
  'sn.rules.r3': "Hitting a wall, an obstacle, yourself or another snake’s body knocks you out (Classic can turn walls off to wrap around).",
  'sn.rules.r4': "Head-on: the longer snake survives; equal lengths both go out.",
  'sn.rules.r5': "A fallen snake leaves food behind; knocking out a rival (they run into you) is worth 50 points.",
  'sn.rules.r6': "The last snake alive wins; when time runs out, the longest living snake wins.",
  'sn.level.easy.desc': "Chases food, often misjudges.",
  'sn.level.medium.desc': "Avoids obstacles and plans safe routes.",
  'sn.level.hard.desc': "Pathfinding, space prediction, cuts you off.",
  'sn.setup.speed': "Speed",
  'sn.setup.map': "Map",
  'sn.setup.walls': "Border walls (off = wrap around the edges)",
  'sn.setup.color': "Snake colour",
  'sn.setup.color1': "Player 1 colour",
  'sn.setup.color2': "Player 2 colour",
  'sn.setup.customNote': "Custom settings keep a local best only; the standard settings (open map, walls on, normal speed) count for the leaderboard.",
  'sn.speed.slow': "Slow",
  'sn.speed.normal': "Normal",
  'sn.speed.fast': "Fast",
  'sn.map.open': "Open",
  'sn.map.pillars': "Pillars",
  'sn.map.cross': "Cross",
  'sn.map.rooms': "Rooms",
  'sn.hud.len': "Length",
  'sn.hud.crashes': "Crashes",
  'sn.hud.best': "Best {n}",
  'sn.hud.controls': "Arrows / WASD / swipe / D-pad, Space to pause",
  'sn.hud.dpad': "D-pad",
  'sn.hud.pause': "Pause",
  'sn.hud.resume': "Resume",
  'sn.hud.paused': "Paused",
  'sn.ev.gold': "{name} got the gold star!",
  'sn.ev.died.wall': "{name} hit a wall",
  'sn.ev.died.self': "{name} bit itself",
  'sn.ev.died.body': "{name} ran into another snake",
  'sn.ev.died.head': "{name} crashed head-on",
  'sn.ev.died.left': "{name} left the game",
  'sn.end.over': "Game over",
  'sn.end.newBest': "New personal best!",
  'sn.end.stats': "Longest {len} · ate {foods} · knockouts {kills}",
  'sn.end.reason.last_standing': "Last snake standing",
  'sn.end.reason.all_dead': "Every snake is out",
  'sn.end.reason.time': "Time is up",
  'sn.end.reason.crash': "Crashed",
  'sn.room.title': "Snake room",
  'sn.room.note': "Share the link to invite friends; the host can add computer snakes and start with 2–8 players.",
  'sn.match.note': "With 2+ players the match starts within about 10 s; if nobody joins within 20 s it starts anyway, with computers filling up to 4.",
  'sn.learn.s1.title': "Steering",
  'sn.learn.s1.text': "Your snake always moves forward. Turn with the arrow keys, WASD or a swipe — make 3 turns.",
  'sn.learn.s2.title': "Eat",
  'sn.learn.s2.text': "Red berries make you longer and score points. Eat 3!",
  'sn.learn.s3.title': "Don’t bite yourself",
  'sn.learn.s3.text': "The longer you are, the harder it is to turn around. Grow to 9 without hitting your own body.",
  'sn.learn.s4.title': "Versus",
  'sn.learn.s4.text': "In the arena, hitting another body knocks you out and the longer snake wins a head-on. Survive 15 seconds next to a computer snake and eat 2 berries.",
  'sn.learn.s5.title': "Ready",
  'sn.learn.s5.text': "Classic, Survival and Time Attack each have a leaderboard; the Multiplayer Arena holds up to 8 players. Go play!",
  'sn.learn.food': "Eaten {n}/3",
  'sn.learn.len': "Length {n}/9",
  'sn.learn.secs': "Survived {n}/15 s",
  'bl.mode.classic': "Classic",
  'bl.mode.classic.desc': "Start at level 1, level up every 10 lines, clear 150 lines to win.",
  'bl.mode.marathon': "Marathon",
  'bl.mode.marathon.desc': "Endless play with ever-faster speed — go for the high score.",
  'bl.mode.sprint': "Sprint",
  'bl.mode.sprint.desc': "Clear 40 lines as fast as possible.",
  'bl.mode.ultra': "Time Attack",
  'bl.mode.ultra.desc': "Best score in 2 minutes.",
  'bl.mode.ai': "VS Computer",
  'bl.mode.ai.desc': "Real-time battle against three AI levels — clear lines to send garbage.",
  'bl.mode.local': "Local VS",
  'bl.mode.local.desc': "Two players side by side on one keyboard.",
  'bl.mode.online': "Online VS",
  'bl.mode.online.desc': "Create a private room and invite a friend.",
  'bl.mode.match': "Quick Match",
  'bl.mode.match.desc': "Automatic matchmaking; after 20 s with nobody you play the computer.",
  'bl.mode.ranked': "Ranked Battle",
  'bl.mode.ranked.desc': "Signed-in players matched by rating; results change your Elo.",
  'bl.mode.learn': "Tutorial",
  'bl.mode.learn.desc': "Six interactive steps: move, rotate, drop, clear, hold, quad.",
  'bl.rules.title': "Block Puzzle Battle rules (JY Blocks Rules v1.0)",
  'bl.rules.r1': "Seven pieces come from a shuffled \"bag of 7\", with 5 next pieces shown; each piece can be held once.",
  'bl.rules.r2': "Rotation uses SRS with wall kicks; a grounded piece locks after 0.5 s, with at most 15 resets.",
  'bl.rules.r3': "Scoring (× level): single 100, double 300, triple 500, quad 800; T-spin single/double/triple 800/1200/1600.",
  'bl.rules.r4': "Consecutive difficult clears (quads, T-spin clears) earn Back-to-Back ×1.5; combos add 50 × combo × level; perfect clears score a bonus.",
  'bl.rules.r5': "Soft drop 1 point per row, hard drop 2; level up every 10 lines for faster gravity.",
  'bl.rules.r6': "Versus: double sends 1, triple 2, quad 4, T-spin double 4, B2B +1, plus combo bonus; attacks first cancel your own incoming garbage.",
  'bl.rules.r7': "Garbage rises when you next lock a piece without clearing, with one gap per batch; you lose if a piece cannot spawn or blocks are pushed off the top.",
  'bl.level.easy.desc': "Simple placement, struggles with tall stacks.",
  'bl.level.medium.desc': "Keeps the stack flat, avoids holes, clears lines.",
  'bl.level.hard.desc': "Stack evaluation, two-piece look-ahead, quads and garbage play.",
  'bl.setup.startLevel': "Start level",
  'bl.setup.levelNote': "Only games started at level 1 count for the leaderboard.",
  'bl.hud.hold': "HOLD",
  'bl.hud.next': "NEXT",
  'bl.hud.lines': "Lines",
  'bl.hud.combo': "Combo {n}",
  'bl.hud.touch': "Touch buttons",
  'bl.hud.controls': "←→ move · ↓ soft drop · Space hard drop · ↑/X rotate right · Z rotate left · A 180° · C hold · Esc pause",
  'bl.hud.controls2p': "P1: A/D move · S soft · W rotate · Q rotate left · E hold · Space hard drop   P2: ←→ · ↓ · ↑ · / rotate left · . hold · Enter hard drop",
  'bl.ctl.left': "Move left",
  'bl.ctl.right': "Move right",
  'bl.ctl.soft': "Soft drop",
  'bl.ctl.hard': "Hard drop",
  'bl.ctl.cw': "Rotate right",
  'bl.ctl.ccw': "Rotate left",
  'bl.ctl.r180': "Rotate 180°",
  'bl.ctl.hold': "Hold",
  'bl.keys.title': "Custom keys and handling (DAS / ARR)",
  'bl.keys.reset': "Reset to defaults",
  'bl.clear.1': "Single",
  'bl.clear.2': "Double",
  'bl.clear.3': "Triple",
  'bl.clear.4': "Quad!",
  'bl.clear.pc': "Perfect clear!",
  'bl.end.cleared': "Cleared!",
  'bl.end.time': "Time’s up",
  'bl.end.draw': "Draw",
  'bl.end.stats': "{lines} lines · {score} points · {time}",
  'bl.end.bestTime': "Best time {t}",
  'bl.end.reason.topout': "The opponent topped out",
  'bl.end.reason.draw': "Both players topped out",
  'bl.end.reason.time': "Time limit reached — more garbage sent wins",
  'bl.room.title': "Block battle room",
  'bl.room.note': "Share the link; the host starts once two players are in — or add a computer opponent.",
  'bl.match.note': "Starts as soon as an opponent is found; after 20 s with nobody you play a Medium computer (not counted in stats).",
  'bl.ranked.login': "Ranked battle requires signing in with Google.",
  'bl.ranked.note': "Your rating: {r}. Players with similar ratings are matched first; the range widens the longer you wait.",
  'bl.learn.s1.title': "Move and rotate",
  'bl.learn.s1.text': "Move the piece with ←→ and rotate with ↑ or X. Move and rotate a few times.",
  'bl.learn.s2.title': "Hard drop and ghost",
  'bl.learn.s2.text': "The dotted outline shows where the piece will land. Press Space to drop instantly — place 3 pieces.",
  'bl.learn.s3.title': "Clear a line",
  'bl.learn.s3.text': "Drop the T piece straight into the gap; a full row disappears.",
  'bl.learn.s4.title': "Hold",
  'bl.learn.s4.text': "Press C or Shift to store the current piece and swap it back later. Try it!",
  'bl.learn.s5.title': "Quad",
  'bl.learn.s5.text': "Turn the long piece upright and move it into the deep well on the right to clear 4 lines at once!",
  'bl.learn.s6.title': "Versus rules",
  'bl.learn.s6.text': "In a battle, clears send garbage to your opponent; consecutive quads, T-spins and combos hit harder. Top them out to win!",
  'onboarding.chess': "Your goal is to checkmate the other king. Select one of your pieces, then a legal destination. If you are unsure, start with the tutorial.",
  'onboarding.xiangqi': "Red moves first. Select a piece to see its legal moves, and protect your general as you attack. A player with no legal moves loses.",
  'onboarding.banqi': "The first piece flipped determines the first player's colour. Each turn, flip, move or capture. A cannon needs exactly one piece between it and its target.",
  'onboarding.territory': "Leave your territory to draw a trail, then return safely to claim the enclosed area. Start with a small loop and watch your trail.",
  'onboarding.snake': "Turn towards food and grow your snake. Leave yourself a safe route before chasing food. Collision rules depend on the selected mode.",
  'onboarding.blocks': "Check the landing spot, then move or rotate the block. Full rows disappear. Hard drop places the block at the bottom immediately, so check before pressing it.",
  'online.syncing': "Connected. Syncing the match…",
  'online.synced': "Match synced.",
  'online.reconnectFailed': "Unable to reconnect for now. Try again or leave the room. The match continues under its original rules.",
  'rules.xiangqi.version': "JY Games Taiwan Xiangqi Rules v1.0",
  'rules.xiangqi.summary': "When the same position and side to move appear for the third time, perpetual check is considered before simplified chase rules. Other repetitions are draws as specified in the rules. See the full rules and examples.",
  'rules.banqi.summary': "Taiwan rules: cannons move one square and capture over exactly one piece; soldiers can capture generals, but not vice versa. Chain captures are off. After 50 consecutive turns without a capture or flip, the game is drawn. One player's action counts as one turn.",
  'tutorial.actionDone': "You did it! Look at how the board changed, then continue.",
  'tutorial.tryAgain': "This step is not complete yet. Check the hint and try again.",
  'tutorial.finish': "Practice complete! Try again or start a game.",
  'onb.title': "Before you start",
  'onb.dismiss': "Got it",
  'onb.show': "How to play",
  'online.retry': "Try again",
  'online.leave': "Leave room",
  'online.away': "offline",
  "game.sudoku": "Sudoku",
  "game.sudoku.desc": "Find the place for every number in a 9×9 grid.",
  "sudoku.title": "Classic Sudoku",
  "sudoku.subtitle": "Single player · Logic",
  "sudoku.rules": "Fill empty cells with 1–9 so that each row, column, and 3×3 box contains no repeated numbers. Given numbers cannot be changed.",
  "sudoku.rules.short": "Every row, column, and box: 1–9, with no repeats",
  "sudoku.difficulty": "Choose difficulty",
  "sudoku.level": "Level",
  "sudoku.easy": "Easy",
  "sudoku.medium": "Medium",
  "sudoku.hard": "Hard",
  "sudoku.easy.desc": "Start with naked and hidden singles.",
  "sudoku.medium.desc": "Practice candidate elimination and pairs.",
  "sudoku.hard.desc": "Try hidden pairs and X-Wing patterns.",
  "sudoku.start": "Start game",
  "sudoku.continue": "Continue game",
  "sudoku.new": "New game",
  "sudoku.more": "More",
  "sudoku.undo": "Undo",
  "sudoku.erase": "Erase",
  "sudoku.notes.on": "Notes: on",
  "sudoku.notes.off": "Notes: off",
  "sudoku.notes.help": "Tap a number to add or remove a candidate. Notes do not count as answers.",
  "sudoku.notes.filled": "Erase the answer before adding notes to this cell.",
  "sudoku.hint": "Hint",
  "sudoku.hint.title": "A clue for your next step",
  "sudoku.hint.apply": "Fill it in",
  "sudoku.hint.eliminate": "Apply elimination",
  "sudoku.hint.close": "Let me try",
  "sudoku.hint.count": "Hints used: {count}",
  "sudoku.hint.conflict": "Resolve the repeated numbers before requesting a hint.",
  "sudoku.hint.contradiction": "The answer in row {row}, column {column} makes this puzzle impossible to complete. Try erasing it and working through the clues again.",
  "sudoku.hint.unavailable": "A hint is temporarily unavailable. Your progress is safe. Please try again.",
  "sudoku.hint.nakedSingle": "After excluding numbers in the same row, column, and box, only {digit} can go in row {row}, column {column}.",
  "sudoku.hint.hiddenSingle": "In {unit}, only row {row}, column {column} can contain {digit}.",
  "sudoku.hint.locked": "In {sourceUnit}, {digit} can only appear in {cells}, so it can be removed from {targetCells}.",
  "sudoku.hint.nakedPair": "In {unit}, {cells} each have only {digits} as candidates. Those numbers occupy these two cells and can be removed from {targetCells}.",
  "sudoku.hint.hiddenPair": "In {unit}, {digits} can only appear in {cells}, so all other candidates can be removed from those two cells.",
  "sudoku.hint.xwing": "In {sourceUnits}, {digit} can only occupy the intersections with {crossUnits}, so it can be removed from {targetCells}.",
  "sudoku.pause": "Pause",
  "sudoku.paused.title": "Take a break",
  "sudoku.paused.desc": "The board and timer are paused",
  "sudoku.resume": "Resume game",
  "sudoku.zoom": "Enlarge box",
  "sudoku.overview": "Full grid",
  "sudoku.box.choose": "Choose a box",
  "sudoku.row": "Row {number}",
  "sudoku.column": "Column {number}",
  "sudoku.box": "Box {number}",
  "sudoku.selection": "Row {row} · Column {column}",
  "sudoku.select.help": "Select a cell, then enter a number.",
  "sudoku.given.locked": "This number is given. Please choose an empty cell.",
  "sudoku.conflict": "A number is repeated. Check the marked cells.",
  "sudoku.restart": "Restart",
  "sudoku.restart.title": "Restart this puzzle?",
  "sudoku.restart.desc": "Your answers, notes, and timer will reset. The completed game will be marked as a replay.",
  "sudoku.new.title": "Start a new puzzle?",
  "sudoku.new.desc": "Your current game will be replaced.",
  "sudoku.cancel": "Keep playing",
  "sudoku.saved": "Saved in this browser",
  "sudoku.save.failed": "Unable to save. Your progress may be lost if you leave.",
  "sudoku.save.invalid": "This saved game could not be loaded. The original data has been kept. You can start a new game.",
  "sudoku.otherTab": "This game is open in another tab. Play is paused here.",
  "sudoku.complete": "Puzzle complete!",
  "sudoku.time": "Time played",
  "sudoku.assisted": "Hints used",
  "sudoku.unassisted": "No hints used",
  "sudoku.replayed": "Replay",
  "sudoku.next": "Play another",
  "sudoku.viewBoard": "View board",
  "sudoku.back": "Back to lobby",
  "sudoku.history": "Recent completions",
  "sudoku.history.local": "Records are stored only in this browser and do not sync to other devices.",
  "sudoku.teach.row": "Every row must contain 1–9, with no repeats.",
  "sudoku.teach.column": "Every vertical column must also contain 1–9.",
  "sudoku.teach.box": "Each 3×3 box outlined by bold lines must contain 1–9.",
  "sudoku.teach.single": "Check the row, column, and box to find the only number that fits this cell.",
  "sudoku.teach.notes": "Use Notes to track candidates. When you need help, a hint explains the next step.",
  "sudoku.teach.success": "That's right. Continue to the next step.",
  "sudoku.teach.retry": "Check the related row, column, and box again.",
  "sudoku.a11y.grid": "Sudoku grid",
  "sudoku.a11y.keypad": "Number pad",
  "sudoku.a11y.cell": "Row {row}, column {column}, box {box}; {content}; {state}",
  "sudoku.a11y.empty": "Empty",
  "sudoku.a11y.given": "Given",
  "sudoku.a11y.entry": "Answer",
  "sudoku.a11y.notes": "Notes {digits}",
  "sudoku.a11y.conflict": "Repeated number",
  "sudoku.saving.none": "Not saved yet",
  "sudoku.records.empty": "No finished games yet.",
  "sudoku.hints": "Hints",
  "sudoku.learn": "How to play",
  "sudoku.selectBox": "Box {number}",
  "sudoku.restart.confirm": "Restart",
  "sudoku.new.confirm": "Start new puzzle",
  "sudoku.teach.title": "Sudoku tutorial",
  "sudoku.teach.next": "Next",
  "sudoku.teach.done": "Tutorial complete! Try a puzzle.",
  "sudoku.teach.toggleNotes": "Turn notes on and add a candidate to this cell.",
  "sudoku.giveUp": "Discard save",
  'footer.copyright': '© {y} JetNet Ltd.',
};
